// Free Samples Functionality
// =============================================================================

// Global variables
var FEGlobal = {
  CheckedCount: 0,
  FreeCheckedCount: 0,
  FreeCheckOutShown: false,
  isFreeSamplesOpen: false,
  // ADDED: Currency thresholds in cents/pence
  Thresholds: {
    'GBP': 7500,  // £75
    'EUR': 15000, // €150
    'USD': 15000  // $150
  },
  DefaultThreshold: 7500 // Fallback to £75 if currency isn't found
};

// Helper function to get the correct threshold based on the cart's currency
function getThresholdForCurrency(currencyCode) {
  if (currencyCode && FEGlobal.Thresholds[currencyCode]) {
    return FEGlobal.Thresholds[currencyCode];
  }
  return FEGlobal.DefaultThreshold;
}

// Native Shopify cart API functions
function getCart() {
  return fetch('/cart.js')
    .then(response => response.json());
}

function addItemsToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: items
    })
  })
  .then(response => response.json());
}

function removeItemFromCart(lineItemKey) {
  console.log('Removing line item key:', lineItemKey);
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: 0
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to remove item: ' + response.status);
    }
    return response.json();
  });
}

// Function to remove quantity controls for free samples in cart-item elements
function removeFreeSampleQuantityControls() {
  setTimeout(function() {
    getCart().then(function(cart) {
      var freeSampleVariantIds = [];
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_type === 'sample' && cart.items[i].price === 0) {
          freeSampleVariantIds.push(cart.items[i].variant_id);
        }
      }
      
      if (freeSampleVariantIds.length > 0) {
        freeSampleVariantIds.forEach(function(variantId) {
          var cartItems = document.querySelectorAll('.cart-item');
          
          cartItems.forEach(function(cartItem) {
            var isMatchingVariant = cartItem.getAttribute('data-variant-id') === variantId.toString() ||
                                  cartItem.querySelector('[data-variant-id="' + variantId + '"]') ||
                                  cartItem.innerHTML.includes(variantId.toString());
            
            if (isMatchingVariant) {
              var quantityElement = cartItem.querySelector('.cart-quantity');
              if (quantityElement) {
                quantityElement.remove();
              }
            }
          });
        });
      }
    }).catch(function(error) {
      console.error('Error removing free sample quantity controls:', error);
    });
  }, 500);
}

function updateCartDisplay() {
  document.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
    detail: { open: true }
  }));

  return getCart().then(cart => {
    var cartCount = document.querySelector('.js-cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    var cartTotal = document.querySelector('.js-cart-total');
    if (cartTotal && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      cartTotal.textContent = Shopify.formatMoney(cart.total_price);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));

    removeFreeSampleQuantityControls();
    return cart;
  });
}

function openFreeSamplesModal() {
  var modal = document.getElementById('free-samples-modal');
  if (modal) {
    modal.classList.add('modal--open');
    document.body.classList.add('modal-open');
    initializeModalContent();
    FEGlobal.isFreeSamplesOpen = true;
  }
}

function closeFreeSamplesModal() {
  var modal = document.getElementById('free-samples-modal');
  if (modal) {
    modal.classList.remove('modal--open');
    document.body.classList.remove('modal-open');
  }
  FEGlobal.isFreeSamplesOpen = false;
}

function initializeModalContent() {
  getCart().then(cart => {
    FEGlobal.FreeCheckedCount = 0;

    var checkboxes = document.querySelectorAll('input.js-free-sample-check');
    var addButton = document.querySelector('.js-add-free-samples');

    var samplesInCart = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_type === 'sample' && cart.items[i].price === 0) {
        samplesInCart.push(cart.items[i].variant_id);
      }
    }

    if (addButton) {
      addButton.disabled = false;
      if (samplesInCart.length > 0) {
        addButton.textContent = 'Update shopping bag';
      } else {
        addButton.textContent = 'Add to shopping bag';
      }
    }

    checkboxes.forEach(function(checkbox) {
      checkbox.checked = false;
      checkbox.disabled = false;
    });

    var checkedCount = 0;
    checkboxes.forEach(function(checkbox) {
      if (samplesInCart.indexOf(parseInt(checkbox.value)) !== -1) {
        checkbox.checked = true;
        checkedCount++;
      }
    });

    FEGlobal.FreeCheckedCount = checkedCount;

    if (checkedCount >= 2) {
      checkboxes.forEach(function(checkbox) {
        if (!checkbox.checked) {
          checkbox.disabled = true;
        }
      });
    }
  });
}

function setupCheckboxHandlers() {
  var checkboxes = document.querySelectorAll('input.js-free-sample-check');
  checkboxes.forEach(function(checkbox) {
    checkbox.removeEventListener('change', handleCheckboxChange);
    checkbox.addEventListener('change', handleCheckboxChange);
  });
}

function handleCheckboxChange(e) {
  var checkboxes = document.querySelectorAll('input.js-free-sample-check');
  var checkedCount = 0;

  checkboxes.forEach(function(cb) {
    if (cb.checked) {
      checkedCount++;
    }
  });

  FEGlobal.FreeCheckedCount = checkedCount;

  checkboxes.forEach(function(cb) {
    if (FEGlobal.FreeCheckedCount >= 2) {
      if (!cb.checked) {
        cb.disabled = true;
      }
    } else {
      cb.disabled = false;
    }
  });
}

function setupAddButtonHandler() {
  var addButton = document.querySelector('.js-add-free-samples');
  if (addButton) {
    addButton.removeEventListener('click', handleAddButtonClick);
    addButton.addEventListener('click', handleAddButtonClick);
  }
}

function handleAddButtonClick(e) {
  var addButton = e.target;
  getCart().then(function(cart) {
    var currentSampleLineItems = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_type === 'sample' && cart.items[i].price === 0) {
        currentSampleLineItems.push({
          key: cart.items[i].key,
          variant_id: cart.items[i].variant_id
        });
      }
    }

    var selectedInModal = [];
    var checkboxes = document.querySelectorAll('input.js-free-sample-check:checked');

    checkboxes.forEach(function(checkbox) {
      selectedInModal.push(parseInt(checkbox.value));
    });

    addButton.disabled = true;
    addButton.textContent = 'Updating...';

    var removePromise;
    if (currentSampleLineItems.length > 0) {
      removePromise = currentSampleLineItems.reduce(function(promise, lineItem) {
        return promise.then(function() {
          return removeItemFromCart(lineItem.key);
        });
      }, Promise.resolve());
    } else {
      removePromise = Promise.resolve();
    }

    removePromise
      .then(function() {
        if (selectedInModal.length > 0) {
          var itemsToAdd = selectedInModal.map(function(variantId) {
            return { id: variantId, quantity: 1 };
          });
          return addItemsToCart(itemsToAdd);
        } else {
          return Promise.resolve({ items: [] });
        }
      })
      .then(function(response) {
        return updateCartDisplay();
      })
      .then(function(cart) {
        closeFreeSamplesModal();
      })
      .catch(function(error) {
        console.error('Error updating free samples:', error);
        getCart().then(function(cart) {
          var samplesInCart = cart.items.filter(function(item) {
            return item.product_type === 'sample' && item.price === 0;
          });
          
          addButton.disabled = false;
          if (samplesInCart.length > 0) {
            addButton.textContent = 'Update shopping bag';
          } else {
            addButton.textContent = 'Add to shopping bag';
          }
        });
        alert('Sorry, there was an error updating the samples. Please try again.');
      });

  }).catch(function(error) {
    console.error('Error getting cart:', error);
    addButton.disabled = false;
    addButton.textContent = 'Add to shopping bag';
  });
}

function AddFreeSamples() {
  setupCheckboxHandlers();
  setupAddButtonHandler();
}

// Cart function using native events
function Cart() {
  document.addEventListener('cart:updated', function(evt) {
    var cart = evt.detail.cart;
    var freeSampleIds = [];

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_type === 'sample' && cart.items[i].price === 0) {
        freeSampleIds.push({
          key: cart.items[i].key,
          variant_id: cart.items[i].variant_id,
          quantity: cart.items[i].quantity
        });
      }
    }

    var freeGiftElement = document.querySelector('.js-cart-free-gift');
    
    // Check dynamic threshold based on currency
    var currentThreshold = getThresholdForCurrency(cart.currency);

    if (cart.total_price >= currentThreshold) {
      if (freeGiftElement) freeGiftElement.style.display = 'block';
      
      if (!FEGlobal.FreeCheckOutShown) {
        setTimeout(function() {
          openFreeSamplesModal();
          FEGlobal.FreeCheckOutShown = true;
        }, 500);
      }
    } else {
      if (freeGiftElement) freeGiftElement.style.display = 'none';
      FEGlobal.FreeCheckOutShown = false;

      if (freeSampleIds.length > 0) {
        var removePromises = freeSampleIds.map(function(sample) {
          return removeItemFromCart(sample.key);
        });

        Promise.all(removePromises).then(function() {
          return updateCartDisplay();
        }).catch(function(error) {
          console.error('Error removing free samples:', error);
        });
      }
    }

    removeFreeSampleQuantityControls();
  });
  
  document.addEventListener('shopify:section:load', function() {
    removeFreeSampleQuantityControls();
  });
  
  document.addEventListener('cart:refresh', function() {
    removeFreeSampleQuantityControls();
  });
  
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var cartChanged = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && 
            (mutation.target.classList.contains('cart-item') || 
             mutation.target.closest('.cart-item') ||
             mutation.target.classList.contains('cart-items') ||
             mutation.target.closest('.cart-items'))) {
          cartChanged = true;
        }
      });
      
      if (cartChanged) {
        removeFreeSampleQuantityControls();
      }
    });
    
    var cartContainer = document.querySelector('cart-items') ||
                       document.querySelector('.cart-items') ||
                       document.querySelector('#cart-items');
    if (cartContainer) {
      observer.observe(cartContainer, {
        childList: true,
        subtree: true
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    removeFreeSampleQuantityControls();
  });
  
  document.addEventListener('click', function(e) {
    if (e.target.matches('.js-cart-toggle, .cart-toggle, [data-cart-toggle]') ||
        e.target.closest('.js-cart-toggle, .cart-toggle, [data-cart-toggle]')) {
      setTimeout(function() {
        removeFreeSampleQuantityControls();
      }, 1000);
    }

    if (e.target.matches('[data-cart-remove], .cart-remove, .js-cart-remove') ||
        e.target.closest('[data-cart-remove], .cart-remove, .js-cart-remove')) {
      setTimeout(function() {
        removeFreeSampleQuantityControls();
      }, 1500);
    }
  });
}

function setupModalTriggers() {
  document.addEventListener('click', function(e) {
    if (e.target.matches('[href="#free-samples-modal"]') ||
        e.target.closest('[href="#free-samples-modal"]')) {
      e.preventDefault();
      openFreeSamplesModal();
      return;
    }

    if (e.target.matches('.js-modal-close') ||
        e.target.matches('[data-modal-close]') ||
        e.target.matches('.modal__close') ||
        e.target.closest('.js-modal-close') ||
        e.target.closest('[data-modal-close]') ||
        e.target.closest('.modal__close')) {
      e.preventDefault();
      closeFreeSamplesModal();
      return;
    }

    if (e.target.matches('.modal__overlay')) {
      closeFreeSamplesModal();
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.keyCode === 27 && FEGlobal.isFreeSamplesOpen) { 
      closeFreeSamplesModal();
    }
  });
}

function initFreeSamples() {
  Cart();
  AddFreeSamples();
  setupModalTriggers();

  getCart().then(function(cart) {
    var freeGiftElement = document.querySelector('.js-cart-free-gift');
    var currentThreshold = getThresholdForCurrency(cart.currency);

    if (cart.total_price >= currentThreshold) {
      if (freeGiftElement) freeGiftElement.style.display = 'block';
      FEGlobal.FreeCheckOutShown = true; 
    } else {
      if (freeGiftElement) freeGiftElement.style.display = 'none';
      FEGlobal.FreeCheckOutShown = false;
    }
  });

  removeFreeSampleQuantityControls();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeSamples);
} else {
  initFreeSamples();
}